<template lang="pug">
  div
    validation-observer(ref='validation' tag='form')
    app-divider(label="Responsável", :addMarginTop="false").margin-bottom
    el-row.labelDiv(:gutter="30").margin-bottom
      el-col.inputDiv(:span="12")
        validation-provider(rules="required", v-slot="{ errors }" :name="nomeAba + '/Nome do responsável'")
          app-label(label="Nome:")
          el-input.input(
            v-model='responsavel.nome',
            :value='responsavel.nome',
            :class="{'erro' : errors.length}"
            maxlength="100"
          )
          span.help.erro {{ errors[0] }}

      el-col.inputDiv(:span="12")
        validation-provider(rules="required", v-slot="{ errors }" :name="nomeAba + '/Formação do responsável'")
          app-label(label="Formação:")
          el-input.input(
            v-model='responsavel.formacao',
            :value='responsavel.formacao',
            :class="{'erro' : errors.length}"
            maxlength="100"
          )
          span.help.erro {{ errors[0] }}

    el-row.labelDiv(:gutter="30")
      el-col.inputDiv(:span="12")
        validation-provider(rules="required", v-slot="{ errors }" :name="nomeAba + '/CREA/RNP do responsável'")
          app-label(label="RNP:")
          el-input.input(
            v-model='responsavel.creaRnp',
            :value='responsavel.creaRnp',
            :class="{'erro' : errors.length}"
            maxlength="100"
          )
          span.help.erro {{ errors[0] }}

      el-col.inputDiv(:span="12")
        validation-provider(rules="required", v-slot="{ errors }" :name="nomeAba + '/Código de credenciamento no INCRA'")
          app-label(label="Código de credenciamento no INCRA:")
          el-input.input(
            v-mask="'XXXX'",
            v-model='responsavel.codigoIncra',
            :value='responsavel.codigoIncra',
            :class="{'erro' : errors.length}"
            maxlength="100"
          )
          span.help.erro {{ errors[0] }}

</template>
<script>
import AppDivider from '@/components/AppDivider'
import AppLabel from '@/components/AppLabel'

export default {
  components: {
    AppLabel,
    AppDivider
  },
  props: {
    nomeAba: {
      type: String,
      required: true
    },
    responsavel: {
      type: Object
    }
  }
}
</script>
<style scoped>
  .margin-bottom {
    margin-bottom: 10px;
  }

  @media (max-width: 780px) {
    .labelDiv {
      display: flex;
      flex-direction: column;
    }

    .inputDiv {
      width: 85%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/AppDadosResponsavel.vue